module.exports = __webpack_public_path__ + "img/Logo-light.82b9db7a.png";